// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// This whole app is the staff admin panel - a plain "user" account (the
// role every public /register call creates) has no business past login
// here, even though the server already rejects its actual write attempts.
const STAFF_ROLES = ["super_admin", "admin"];

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // Wait for loading to complete
    if (loading) {
        return <div>Loading...</div>;
    }

    // If not logged in, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Logged in, but not a staff role - don't let a customer/self-registered
    // account see the admin shell at all, not even the parts that would
    // eventually 403 on their own.
    if (!STAFF_ROLES.includes(user.role)) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
